Object.defineProperties(exports, {
	__esModule: { value: true },
	[Symbol.toStringTag]: { value: "Module" }
});
const require_utilities = require("./utilities.js");
const require_domparser = require("./domparser.js");
//#region src/client/html-to-dom.ts
const DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/;
/**
* Parses HTML string to DOM nodes in browser.
*
* @param html - HTML markup.
* @param options - Parser options.
* @returns - DOM elements.
*/
function HTMLDOMParser(html, options) {
	if (typeof html !== "string") throw new TypeError("First argument must be a string");
	if (!html) return [];
	const match = DIRECTIVE_REGEX.exec(html);
	const directive = match ? match[1] : void 0;
	return require_utilities.formatDOM(require_domparser.default(html, options?.trustedTypePolicy), null, directive);
}
//#endregion
exports.default = HTMLDOMParser;

//# sourceMappingURL=html-to-dom.js.map